@if (roomNav.pages.length > 1) {
<ul id="tour-balance-tabs" class="pro-tabs">
  @for (page of roomNav.pages; track page.name) {
  <li class="pro-tabs__tab" routerLinkActive="pro-tabs__tab--active" [routerLink]="page.path">{{ page.name }}</li>
  }
</ul>
}
